<template>
  <div>
    <div class="offcanvas offcanvas-start" style="width:65%" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
        <div class="offcanvas-header" :style="skin.side_bar.header + skin.side_bar.header_text" style="display: none;">
            <button id="closeSideBar" type="button" class="btn text-reset" data-bs-dismiss="offcanvas" aria-label="Close">
                <span style="color:white;font-size:large"><i class="fas fa-times"></i></span>
            </button>
        </div>
        <div class="offcanvas-body p-0" :style="skin.side_bar.body">
            <div class="p-3">
                <div v-for="item in filteredCategories" :key="item.category" @click="change_view(item.category)" class="p-2">
                    <div class="d-flex">
                        <i v-if="item.iconClass" :class="item.iconClass" class="me-1" style="width:36px;height:36px"></i>
                        <img v-else :src="item.icon" class="me-1" style="width:36px;height:36px">
                        &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">{{menuLabel(item)}}</span>
                    </div>
                </div>
                <div class="pt-2">
                    <div class="p-2">
                        <span :style="skin.side_bar.navigation_text">{{ translate('others') }}</span>
                    </div>
                    <div v-if="user?.user_data?.data?.parentPhone" class="p-2">
                        <a :href="'https://api.whatsapp.com/send?phone=' + user.user_data?.data?.parentPhone"
                            target="_blank" rel="noopener" class="action-btn whatsapp-btn">
                            <i class="fab fa-whatsapp"></i>
                            <span>{{ translate('whatsapp') }}</span>
                        </a>
                    </div>
                    <div v-if="user?.user_data?.data?.cuenta" class="p-2">
                        <button type="button" class="action-btn recargar-btn" @click="openContactAgent">
                            <i class="fa fa-refresh"></i>
                            <span>Recargar</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>  
        <historialIngresos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
    </div>
  </div>
</template>

<script>
import languageSelector from '../../header/language.vue';
import historialIngresos from "../../header/historialIngresos.vue";
import { getGamanzaMenuCategories, isGamanzaMenuCategory } from '@/utils/gamanzaMenuCategories';
export default {
    name: 'Sidebar',
    components: {
        languageSelector,
        historialIngresos
    },
    props:['translation','language'],
    data(){
        return {
        booking_code:'',
        }
    },
    computed:{
        filteredCategories() {
            const categories = this.skin.categories.filter(category => category.active);
            return [...categories, ...getGamanzaMenuCategories(this.skin, this.user, this.gamanzaReady, this.language)];
        },
        gamanzaReady(){
            return this.$store.getters['getGamanzaReady'];
        },
        favoritos(){
            return this.$store.getters['live/getFavorites']; 
        },
        sports(){
           return this.$store.getters['live/getSports'];
        },
        skin(){
            return this.$store.getters['getCurrentSkin'];
        },
        user(){
            return this.$store.getters['getUserData'];
        },
        prematchTarget(){
            return this.$store.getters['getPrematchTarget'];
        },
        time2(){
            return this.$store.getters['prematch_2/getTime'];
        },
        timeLoading(){
            return this.$store.getters['prematch_2/getTimeLoading'];
        },
        sports_prematch(){
            return  this.$store.getters['prematch_2/getSports'];
        },
        nav_activeCss(){
            return {
            '--bar':this.skin.side_bar.nav_active_bar,
            '--text':this.skin.side_bar.nav_active_text,
            }
        },
        config(){
            return this.$store.getters['getConfig'];
        },
    },
    methods:{
        menuLabel(item) {
            return isGamanzaMenuCategory(item.category)
                ? item.name
                : this.translate(item.name);
        },
        translate(text) {
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
        active: function (id) {
            let items = document.getElementsByClassName("item-menu");
            [...items].forEach(item=>{
                item.classList.remove('nav_active1');
                item.classList.remove('active');
            });
            document.getElementById(id).classList.add('nav_active1');
            document.getElementById(id).classList.add('active');
        },
        check_booking(){
            if(this.booking_code!=''){
                this.$store.dispatch('getBooking',this.booking_code);
            }
            else{
                this.alert.message=this.translate('Ingresa un código de reserva válido');
                this.alert.type='danger';
                this.alert.active=true;
                setTimeout(this.alert_off,5000);
            }
        },
        change_view(view){
            document.getElementById('closeSideBar').click();
            this.$store.dispatch("changeView", view);
        },
        terms(){
            let url = "";
            let lang = this.$props.language=='es'?'spa':(this.$props.language=='en'?'eng':(this.$props.language=='pt'?'pt-br':'spa'));
            if(this.user.prefix=="external"){
                url = "https://docs.betsw3.xyz/terms/"+lang+"/?site="+this.user.site.toUpperCase()+"&link="+this.user.site;
            }
            else{
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1]+'.'+domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/"+lang+"/?site="+domain_name1+"&link="+domain_name2;
            }
            
            window.open(url, '_blank').focus();
        },
        openContactAgent(){
            document.getElementById('closeSideBar').click();
            this.$root.$emit('openContactAgent');
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-group2 {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}
.nav_active1{
  color:var(--text);
  border-bottom:var(--bar);
}

.action-btn{
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px 10px;
    border-radius: 10px;
    border: none;
    text-decoration: none;
    font-weight: 700;
    line-height: 1.1;
}
.whatsapp-btn{
    background: #25D366;
    color: #ffffff;
}
.recargar-btn{
    background: #c9a227;
    color: #1c1c1c;
}
.action-btn:hover{
    filter: brightness(1.05);
}
</style>
